import React from 'react';
import propTypes from 'prop-types';
import { TriangleAlert } from 'lucide-react';
import Modal from 'tailwind-components/Modal/Modal';
import Button from 'tailwind-components/Button/Button';

function ExportPendingAppointmentsModal({
  open,
  onClose,
  excludedAgencies,
  onContinueWithout,
  onContinueWithSelected,
  canContinueWithSelected
}) {
  const footer = (
    <div className='flex w-full items-center justify-end gap-3'>
      <Button
        variant='secondary'
        size='small'
        text='Cancel'
        onClick={onClose}
      />
      <Button
        variant='default'
        outlined
        size='small'
        text='Continue without agencies'
        onClick={onContinueWithout}
      />
      <Button
        variant='primary'
        size='small'
        text='Continue with selected agencies'
        onClick={onContinueWithSelected}
        isDisabled={!canContinueWithSelected}
      />
    </div>
  );

  return (
    <Modal
      active={open}
      closeModal={onClose}
      size='small'
      title='Export Pending Appointments'
      footer={footer}
    >
      <div className='flex flex-col gap-4'>
        <p className='m-0 flex items-center gap-1.5 text-xs text-amber-600'>
          <TriangleAlert className='size-3.5 shrink-0' />
          You have unapplied changes in your agency selection. The report is
          generated from the currently loaded data.
        </p>
        {excludedAgencies.length > 0 && (
          <div className='flex flex-col gap-2'>
            <p className='m-0 text-sm text-grey-dark'>
              The following agencies will be excluded from this export:
            </p>
            <ul className='m-0 list-disc pl-5 text-sm text-grey-dark'>
              {excludedAgencies.map(a => (
                <li key={a.agencyId}>{a.agencyName}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Modal>
  );
}

ExportPendingAppointmentsModal.propTypes = {
  open: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  excludedAgencies: propTypes.arrayOf(
    propTypes.shape({
      agencyId: propTypes.string.isRequired,
      agencyName: propTypes.string.isRequired
    })
  ).isRequired,
  onContinueWithout: propTypes.func.isRequired,
  onContinueWithSelected: propTypes.func.isRequired,
  canContinueWithSelected: propTypes.bool
};

export default ExportPendingAppointmentsModal;
